import { render, staticRenderFns } from "./LoginPhone.vue?vue&type=template&id=f1ec0912&scoped=true&"
import script from "@/scripts/LoginPhone/index.js?vue&type=script&lang=js&"
export * from "@/scripts/LoginPhone/index.js?vue&type=script&lang=js&"
import style0 from "./LoginPhone.vue?vue&type=style&index=0&id=f1ec0912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ec0912",
  null
  
)

export default component.exports